/**=========================================================
 * Module: group.js
 * Group Controller
 =========================================================*/
App.controller('GroupController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, ngDialog) {
    "use strict";

    $scope.type = 'group';
    $scope.id = $state.params.filter;

    $scope.model = {};
    $scope.error = {};
    $scope.page = {
        title: '',
        subTitle: ''
    };
    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        

    	if($rootScope.user.id&&( $scope.id != 'undefined')){
            $scope.initialized = true;
            $scope.decimalSep = $rootScope.user.decimalSep;
            if(!$scope.id){
            	$scope.id = $rootScope.user.group.id;
            }

                $scope.loadFiles = function(){
                    D.query('file','entityId=' + $scope.id +'&type=group&field=uploadlogo', { cache: false }).then(
                        function(response){
                            if(response[0]){
                                $scope.model.logo=response[0].url;
                            }
        
                            $scope.uploadedFiles = response;
                        }
                    ).catch(console.error);
                };

            let loadedSessions = 0
            let loadSessions = function(index){
                D.query('session', 'accountid=' + $scope.data[index].id).then(function(r){
                    loadedSessions++
                    if(loadedSessions==$scope.data.length){
                        $scope.table.fields.find(function(f){ return f.name=='lastSeen' }).loadingData = false
                    }
                    let ls = null
                    for(var i=0; i<r.length; i++){
                        if(ls===null || r[i].T>ls) ls = r[i].T
                    }
                    $scope.data[index].lastSeen = ls
                })
            }
		    /*---------------------------------------------------*/
            D.load('group', $scope.id, { cache: false }).then(function(resp){
                $scope.group = resp
                var isClient = resp.type=='CLIENT';
                if($state.params.action=='view')
                D.query('account', 'group='+$scope.id + '&_withGroup=true&_withCustom=true', { cache: false }).then(
                        function(response){
                            response.sort((a,b) => { 
                                if(a.enabled && !b.enabled) return -1;
                                if(!a.enabled && b.enabled) return 1;
                                if(a.customRole && !b.customRole) return 1;
                                if(!a.customRole && b.customRole) return -1;
                                return a.name > b.name ? 1 : -1
                            })
                            $scope.data = response;

                            for(var i=0; i<$scope.data.length; i++){
                                if($scope.data[i].customRole=='REVIEWER'){
                                    $scope.data[i].customRoleSuffix = $scope.data[i].opts.isDefaultReviewer ? '*' : ''
                                    $scope.data[i].customRoleSuffix += ' [' + $filter('translate')('enums.language.'+$scope.data[i].opts.reviewLanguage) +']'
                                }
                                $scope.data[i].gdprcheckdate = $scope.data[i].opts.gdprcheckdate
                                loadSessions(i)
                            }

                            var link3cond=isClient;
                            

                            
                            $scope.table = {
                                    title: '',
                                    cls: 'no-panel-table',
                                    fields: [
                                        {
                                            available: true,
                                            hasLink: true,
                                            name: 'name'
                                        },{
                                            available: true,
                                            name: 'username'
                                        },{
                                            available: true,
                                            name: 'email'
                                        },{
                                            available: true,
                                            name: 'superUser',
                                            type: 'boolean'
                                        },{
                                            available: true,
                                            name: 'enabled',
                                            type: 'boolean'
                                        },{
                                            available: $scope.data.length && $scope.data[0].groupType=='CLIENT' && !!$scope.data[0].group.supergroup,
                                            name: 'sgUser',
                                            label: 'supergroupUser',
                                            type: 'boolean'
                                        },{
                                            available: true,
                                            name: 'customRole',
                                            type: 'enum',
                                            enumType: 'customRole',
                                            suffixField: 'customRoleSuffix'
                                        },{
                                            available: true,
                                            name: 'lastSeen',
                                            type: 'date',
                                            format: 'fromNow',//'L HH:mm:ss',
                                            loadingData: true
                                        },{
                                            available: $scope.group.type=='CLIENT' || $scope.group.type=='SUPPLIER',
                                            name: 'gdprcheckdate',
                                            type: 'date',
                                            format: 'L HH:mm:ss'
                                        }
                                    ],
                                    link: {
                                        action: 'view',
                                        type: 'user',
                                        filter: 'id'
                                    },
                                    links: [{
                                        link: {
                                            action: 'create',
                                            type:'user',
                                            filterValue: $scope.id
                                        },
                                        label: 'labels.ADDNEWUSER',
                                        icon: 'aqi-action-add'
                                    },{
                                        link: (!$rootScope.user.admin && !$rootScope.user.groupType=='ADM') || $scope.id=='adm' ? null : {
                                            action: 'edit',
                                            type:'group',
                                            filterValue: $scope.id
                                        },
                                        label: 'labels.EDITGROUP',
                                        icon: 'aqi-action-edit'
                                    },{
                                        link: !($rootScope.user.admin && $rootScope.user.groupType=='ADMIN' && link3cond) ? null : {
                                            action: 'manage',
                                            type:'references',
                                            filterValue: $scope.id
                                        },
                                        label: 'labels.EDITREFERENCE',
                                        icon: 'aqi-reference'
                                    },{
                                        link: !($rootScope.user.admin && $rootScope.user.groupType=='ADMIN' && link3cond) ? null : {
                                            action: 'manage',
                                            type:'sectors',
                                            filterValue: $scope.id
                                        },
                                        label: 'labels.SECTORS',
                                        icon: 'aqi-sectors'
                                    }]
                                }
                        },
                        function(error){
                            $scope.error = error;
                        }
                    ).catch(console.error);
                }).catch(console.error);





            /*---------------------------------------------------*/

            if($state.params.action=='credits'){

                $scope.showCreatingPacket = false;
                var checkTask = function(){
                    D.query('taskresult', 'filter=createPacket_'+$scope.id).then(function(response){
                        if(response && response[0]){
                            var result = response[0].result;
                            if(result.started && !result.ended){
                                $scope.showCreatingPacket = true;
                                $timeout(checkTask, 5000);
                            }
                            if(result.ended){
                                if($scope.showCreatingPacket){
                                    $timeout(function(){ $state.go('app.entity', {
                                        type: 'group',
                                        filter: $scope.id,
                                        action: 'credits'
                                    }, { reload: true }); }, CONFIG.stateGoTimeout)
                                }
                                $scope.showCreatingPacket = false;
                            }
                        }
                    }).catch(console.error)
                }
                checkTask();

                $scope.deleteTransaction = function(p, t){
                    p.transactionToBeDeleted = t
                    delete p.transactionToBeEdited
                    $scope.deletingFromPacket = p
                    $scope.deletingTransaction = t
                    ngDialog.openConfirm({
                        template: '/app/views/entities/confirm-deletetransaction.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope
                      }).then(function (value) {
                          D.save('packet', p).then(function(resp){
                            $timeout(function(){ $state.go('app.entity', {
                                type: 'group',
                                filter: $scope.id,
                                action: 'credits'
                            }, { reload: true }) }, CONFIG.stateGoTimeout)
                          }).catch(console.error)
                      })
                }

                $scope.editTransaction = function(p, t){
                    p.transactionToBeEdited = t
                    delete p.transactionToBeDeleted
                    $scope.editingFromPacket = p
                    $scope.editingTransaction = t
                    var originalWords = t.quantity
                    p.quantity = originalWords
                    $scope.editTransactionForm = {
                        title: '',
                        status: '',
                        type: 'packet',
                        model: p,
                        fields: [
                                 {
                                     available: true,
                                     type: 'number',
                                     name: 'quantity',
                                     decimals: 0,
                                     labelColumn: 4,
                                     inputColumn: 8,
                                     required: true
                                 },{
                                     available: true,
                                     type: 'submit',
                                     name: 'empty',
                                     value: 'fields.SUBMIT'
                                 }
                                 ],
                                 validate: function(){
                                     var errors = [];
                                          for(var i=0; i<this.fields.length; i++){
                                                  var field = this.fields[i];
                                                  if(field.required && !this.model[field.name]){
                                                      errors.push({field:field,error:'required'});
                                                  }
                                          }
                                          if(parseInt(this.model.quantity)>originalWords){
                                            errors.push({field:field,error:'tooMuchWords'});
                                          }
                                          if(errors.length) {
                                              var errorMessages ="<ul>";
                                              for(var i=0; i<errors.length; i++){
                                                  var e = errors[i];
                                                  errorMessages += "<li>"
                                                      +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                      +"</li>";
                                              }
                                              errorMessages += "</ul>";
                                              $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                              return false;
                                          }
                                          else return true;
                                  },
                                 submit: function(){
                                     if(this.validate()){
                                        D.save('packet', p).then(function(resp){
                                            ngDialog.close()
                                            $timeout(function(){ $state.go('app.entity', {
                                                type: 'group',
                                                filter: $scope.id,
                                                action: 'credits'
                                            }, { reload: true }) }, CONFIG.stateGoTimeout)
                                        }).catch(console.error)
                                     }
                                 }
                };

                    ngDialog.open({
                        template: '/app/views/entities/transaction-edit.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope
                      })
                }

		    	D.load($scope.type, $scope.id, { cache: false }).then(
                		function(model){
                			$scope.model = model;
                			$scope.page.subTitle = 'labels.WORDS';
                			$scope.page.title = model.name;

                            $scope.packets = [];
                            $scope.currentPacket = {};

                            var updateCounters = function(){
                                D.load($scope.type, $scope.id).then(
                                    function(model){
                            			$scope.model = model;
                                    }).catch(console.error);
                            }
                            updateCounters();
                            
                            FIREBASE.listen('Counter', 'words_' + $scope.id, function(value){
                                updateCounters();
                            }, null, { interval: 60000 });

                            $scope.loadMorePackets = function(){
                                if($rootScope.user.group.type=='ADMIN' || ($rootScope.user.group.type=='CLIENT' && $rootScope.user.group.opts.viewPacketTransactions && $rootScope.user.superUser)){
                                    D.query('packet', 'range=20&group='+$scope.id + ($scope.packetCursor ? '&cursor='+$scope.packetCursor : '')).then(function(response){
                                        for(var i=0; i<response.length; i++){
                                            if(response[i].open) $scope.currentPacket = response[i];
                                        }
                                        $scope.packets = $scope.packets.concat(response);
                                        $scope.packetCursor = response.cursor;
                                    }).catch(console.error);
                                }
                            }
                            $scope.loadMorePackets();

                            $scope.exportTask = '';
                            $scope.exportUrl = '';
                            $scope.checkExportTask = function(){
                                D.load('taskresult', $scope.exportTask).then(function(response){
                                    if(response && response.result){
                                        var result = response.result;
                                        if(result.ended){
                                            $scope.exportUrl = result.file;
                                            $scope.exportTask = '';
                                        } else {
                                            $timeout($scope.checkExportTask, 5000);
                                        }
                                    }
                                }).catch(console.error);
                            }
                            $scope.exportPackets = function(){
                                D.save('taskresult', {task:'exportPackets',client:$scope.model.id,filename:$filter('translate')('labels.WORDSPACKAGESFILENAME')+'_'+$scope.model.name+'.xlsx',mimetype:'application/vnd.ms-excel'})
                                    .then(function(response){
                                        $scope.exportTask = response.id;
                                        $scope.checkExportTask();
                                    }).catch(console.error);
                            }


                            $scope.deletePacket = function(id){
                                ngDialog.openConfirm({
                                   template: '/app/views/entities/confirm.html',
                                   className: 'ngdialog-theme-default',
                                   scope: $scope
                               }).then(function (value) {
                                  D.remove('packet', id).then(function(){
                                    $timeout(function(){ $state.go('app.entity', {
                                          type: 'group',
                                          filter: $scope.id,
                                          action: 'credits'
                                      }, { reload: true }) }, CONFIG.stateGoTimeout)
                                  }).catch(console.error)
                               });
                            }

                            $scope.customPacket = false;
                            $scope.toggleCustomPacket = function(){
                                $scope.formAdd.model.size=0;
                                $scope.formAdd.fields[0].type=='number' ? $scope.formAdd.fields[0].type='select' : $scope.formAdd.fields[0].type='number'; 
                                $scope.customPacket = !$scope.customPacket;
                            }
                            $scope.transferWords = false;
                            $scope.toggleTransferWords = function(){
                                $scope.formAdd.model.transferFrom=''; 
                                if($scope.transferWords){
                                    $scope.formAdd.model.price = 0.02;
                                    $scope.formAdd.fields[2].available=false;
                                    $scope.formAdd.fields[1].available=true;
                                } else {
                                    $scope.formAdd.fields[2].available=true; 
                                    $scope.formAdd.fields[1].available=false; 
                                }
                                $scope.transferWords = !$scope.transferWords;
                            }

                			$scope.formAdd = {
                					title: '',
                					status: '',
                					type: 'packet',
                					model: { group: $scope.id, size: 0, price: 0 },
                					fields: [
                					         {
                					        	 available: true,
                					        	 type: 'select',
                					        	 name: 'size',
                					        	 data: [{
                					        		 value: 0,
                					        		 label: '-'
                					        	 },{
                					        		 value: 100000,
                					        		 label: $filter('display')(100000, {type:'number'})
                					        	 },{
                                                    value: 150000,
                                                    label: $filter('display')(150000, {type:'number'})
                                                },{
                                                    value: 200000,
                                                    label: $filter('display')(200000, {type:'number'})
                                                },{
                                                    value: 250000,
                                                    label: $filter('display')(250000, {type:'number'})
                                                },{
                					        		 value: 500000,
                					        		 label: $filter('display')(500000, {type:'number'})
                					        	 },{
                					        		 value: 1000000,
                					        		 label: $filter('display')(1000000, {type:'number'})
                					        	 }],
                					        	 valueField: 'value',
                					        	 labelField: 'label',
                					        	 required: true,
                                                 placeholder: ' ',
                					         },{
                                                 available: true,
                                                 type: 'select',
                                                 data: [{
                                                    value: 0,
                                                    label: '-'
                                                },{
                                                    value: 0.02,
                                                    label: $filter('display')(0.02, {type:'currency',decimals:3,decimalSep:$rootScope.user.decimalSep, currency: $scope.model.currency})
                                                },{
                                                    value: 0.019,
                                                    label: $filter('display')(0.019, {type:'currency',decimals:3,decimalSep:$rootScope.user.decimalSep, currency: $scope.model.currency})
                                                },{
                                                    value: 0.018,
                                                    label: $filter('display')(0.018, {type:'currency',decimals:3,decimalSep:$rootScope.user.decimalSep, currency: $scope.model.currency})
                                                },{
                                                    value: 0.017,
                                                    label: $filter('display')(0.017, {type:'currency',decimals:3,decimalSep:$rootScope.user.decimalSep, currency: $scope.model.currency})
                                                },{
                                                    value: 0.016,
                                                    label: $filter('display')(0.016, {type:'currency',decimals:3,decimalSep:$rootScope.user.decimalSep, currency: $scope.model.currency})
                                                },{
                                                    value: 0.015,
                                                    label: $filter('display')(0.015, {type:'currency',decimals:3,decimalSep:$rootScope.user.decimalSep, currency: $scope.model.currency})
                                                }],
                                                valueField: 'value',
                                                 labelField: 'label',
                                                 placeholder: ' ',
                                                 decimals: 5,
                                                 name: 'price',
                                                 postfix: $filter('translate')('enums.currencySymbol.' + $scope.model.currency),
                                                 required: true,
                                                 optionalButton: {
                                                     label: $filter('translate')('labels.CUSTOMPRICE'),
                                                     fn: function(){
                                                        $scope.formAdd.fields[1].type=='decimal' ? $scope.formAdd.fields[1].optionalButton.label=$filter('translate')('labels.CUSTOMPRICE') : $scope.formAdd.fields[1].optionalButton.label=$filter('translate')('labels.FIXEDPRICE');
                                                        $scope.formAdd.fields[1].type=='decimal' ? $scope.formAdd.fields[1].type='select' : $scope.formAdd.fields[1].type='decimal';
                                                        return false;
                                                     }
                                                 }
                                             },{
                                                 available: false,
                                                 type: 'select',
                                                 name: 'transferFrom',
                                                 placeholder: ' ',
                                                 data: [{id:'',name:'-'}].concat($scope.model.siblings),
                                                 valueField: 'id',
                                                 labelField: 'name',
                                                 required: true
                                             },{
                					        	 available: true,
                					        	 type: 'separator'
                					         },{
                					        	 available: true,
                					        	 type: 'submit',
                					        	 name: 'empty',
                					        	 value: 'fields.SUBMIT'
                					         }
                					         ],
                                     validate: function(){
                                            var errors = [];
                                         	for(var i=0; i<this.fields.length; i++){
                                         			var field = this.fields[i];
                                         			if(field.required && field.available && !this.model[field.name]){
                                         				errors.push({field:field,error:'required'});
                                         			}

                                         	}
                                         	if(errors.length) {
                                         		var errorMessages ="<ul>";
                                         		for(var i=0; i<errors.length; i++){
                                         			var e = errors[i];
                                         			errorMessages += "<li>"
                                         				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                         				+"</li>";
                                         		}
                                         		errorMessages += "</ul>";
                                         		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                         		return false;
                                         	}
                                         	else return true;
                                      },
        					         submit: function(){
        					        	 if(this.validate()){
                                             $scope.formAdd.model.price = parseFloat($scope.formAdd.model.price);
                                             $scope.canAddPacket = null;
                                             $scope.formAdd.model.action = 'checkPacket';
                                             D.save('packet',$scope.formAdd.model).then(function(response){
                                                 if(!response) response = {words: 0};
                                                 if(response.words > $scope.formAdd.model.size){
                                                     $scope.canAddPacket = false;
                                                 } else {
                                                     $scope.canAddPacket = true;
                                                 }
                                                 if($scope.formAdd.model.transferFrom){
                                                     if(response.size < $scope.formAdd.model.size){
                                                         $scope.canAddPacket = false;
                                                     }
                                                 }
                                                 $scope.neededPacket = response;
                                                 if($scope.formAdd.model.transferFrom) $scope.formAdd.model.price = $scope.neededPacket.price;
                                                 $scope.decimalSep = $rootScope.user.decimalSep;
                                                ngDialog.openConfirm({
                                                    template: '/app/views/entities/packet-confirm.html',
                                                    className: 'ngdialog-theme-default',
                                                    scope: $scope
                                                }).then(function (value) {
                                                    $scope.formAdd.status = 'submitting';
                                                    if(!$scope.formAdd.fields[2].available){
                                                        delete $scope.formAdd.model.transferFrom;
                                                    }
                                                    delete $scope.formAdd.model.action;
                                                        D.save('packet', $scope.formAdd.model).then(
                                                                function(response){
                                                                    $scope.formAdd.status = 'submitted';
                                                                    $timeout(function(){ $state.go('app.entity', {
                                                                        type: 'group',
                                                                        filter: $scope.id,
                                                                        action: 'credits'
                                                                    }, { reload: true }) }, CONFIG.stateGoTimeout)
                                                                }
                                                                
                                                        ).catch(function(response){
                                                                    $scope.formAdd.status = 'error';
                                                                });
                                                    });
                                             }).catch(console.error);
                                             
        					        	 }
        					         }
                			};


                            D.query('project','group='+$scope.model.id + '&range=250', { cache: false }).then(
                                function(response){

                                    response = [{id:'',code: '-'}].concat(response);
                                    $scope.formSubSpecific = {
                        					title: '',
                        					status: '',
                        					type: 'group',
                        					model: {recoveredFromProject:'', size:0},
                        					fields: [
                        					         {
                        					        	 available: true,
                        					        	 type: 'select',
                        					        	 name: 'recoveredFromProject',
                                                         label: 'fields.RECOVEREDFROMPROJECT',
                        					        	 data: response,
                        					        	 valueField: 'id',
                        					        	 labelField: 'code',
                                                         labelColumn: 4,
                                                         inputColumn: 8,
                                                         required: true
                        					         },{
                                                         available: true,
                                                         type: 'number',
                                                         name: 'size',
                                                         decimals: 0,
                                                         label: 'fields.SIZE',
                                                         labelColumn: 4,
                                                         inputColumn: 8,
                                                         required: true
                                                     },{
                                                        available: true,
                                                        type: 'text',
                                                        name: 'reason',
                                                        labelColumn: 4,
                                                        inputColumn: 8,
                                                        required: true
                                                    },{
                        					        	 available: true,
                        					        	 type: 'separator'
                        					         },{
                        					        	 available: true,
                        					        	 type: 'submit',
                        					        	 name: 'empty',
                        					        	 value: 'fields.SUBMIT'
                        					         }
                        					         ],
                                                     validate: function(){
                                                         var errors = [];
                                                          	for(var i=0; i<this.fields.length; i++){
                                                          			var field = this.fields[i];
                                                          			if(field.required && !this.model[field.name]){
                                                          				errors.push({field:field,error:'required'});
                                                          			}

                                                          	}
                                                          	if(errors.length) {
                                                          		var errorMessages ="<ul>";
                                                          		for(var i=0; i<errors.length; i++){
                                                          			var e = errors[i];
                                                          			errorMessages += "<li>"
                                                          				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                          				+"</li>";
                                                          		}
                                                          		errorMessages += "</ul>";
                                                          		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                                          		return false;
                                                          	}
                                                          	else return true;
                                                      },
                        					         submit: function(){
                                                         var model = this.model;
                        					        	 if(this.validate()){
                                                             ngDialog.openConfirm({
                 	                                            template: '/app/views/entities/confirm.html',
                 	                                            className: 'ngdialog-theme-default',
                 	                                            scope: $scope
                 	                                          }).then(function (value) {
            	                					        	 $scope.formSubSpecific.status = 'submitting';
                                                                 $scope.currentPacket.subtractFromProject = model.recoveredFromProject;
                                                                 $scope.currentPacket.subtractWords = model.size;
                                                                 delete $scope.currentPacket.transactionToBeEdited
                                                                 delete $scope.currentPacket.transactionToBeDeleted
                                                                 delete $scope.currentPacket.transferWords
                                                                 $scope.currentPacket.reason = model.reason;
                                                                 $scope.currentPacket.group = $scope.id;
            	                					        	 D.save('packet', $scope.currentPacket).then(
            	                					        			 function(response){
            	                					        				 $scope.formSubSpecific.status = 'submitted';

            	                					        				 $timeout(function(){ $state.go('app.entity', {
            	                					        					 type: 'group',
            	                					        					 filter: $scope.id,
            	                					        					 action: 'credits'
            	                					        				 }, { reload: true }) }, CONFIG.stateGoTimeout)
            	                					        			 }
            	                					        			 
            	                					        	 ).catch(function(response){
            	                					        				 $scope.formSubSpecific.status = 'error';
                                                                             if(response.data.msg.indexOf('words=')===0){
                                                                                    $scope.formSubSpecific.errorLabel = 'labels.ERRORTOOMANYWORDSFORPACKET';
                                                                             }

            	                					        			 });
                                                            });
                        					        	 }
                        					         }
                                    };

                                    $scope.savingsArray = $scope.model.savings;
                                    $scope.removeSaving = function(index){
                                        ngDialog.openConfirm({
                                            template: '/app/views/entities/confirm.html',
                                            className: 'ngdialog-theme-default',
                                            scope: $scope
                                          }).then(function (value) {
                                            $scope.model.action = 'RemoveGroupSaving';
                                            $scope.model.index = index;
                                            D.save('group', $scope.model).then(function(res){
                                                $timeout(function(){ $state.go('app.entity', {
                                                    type: 'group',
                                                    filter: $scope.id,
                                                    action: 'credits'
                                                }, { reload: true }) }, CONFIG.stateGoTimeout)
                                            }).catch(console.error);
                                          });
                                        
                                    }
                                    
                                    $scope.addSavingForm = {
                                        title: 'labels.ADDSAVING',
                                        status: '',
                                        type: 'group',
                                        model: { project: '', value: 0, description: '' },
                                        fields: [
                                                 {
                                                     available: true,
                                                     type: 'select',
                                                     name: 'project',
                                                     data: response,
                                                     valueField: 'id',
                                                     labelField: 'code',
                                                     labelColumn: 4,
                                                     inputColumn: 8,
                                                     required: true
                                                 },{
                                                     available: true,
                                                     type: 'decimal',
                                                     name: 'value',
                                                     postfix: $filter('translate')('enums.currencySymbol.' + $scope.model.currency),
                                                     decimals: 2,
                                                     labelColumn: 4,
                                                     inputColumn: 8,
                                                     required: true,
                                                     decimalSep: $rootScope.user.decimalSep
                                                 },{
                                                     available: true,
                                                     type: 'textarea',
                                                     name: 'description',
                                                     labelColumn: 4,
                                                     inputColumn: 8
                                                 },{
                                                    available: true,
                                                    type: 'date',
                                                    name: 'date',
                                                    minDate: new Date(2015,1,1),
                                                    labelColumn: 4,
                                                    inputColumn: 8
                                                },{
                                                     available: true,
                                                     type: 'separator'
                                                 },{
                                                     available: true,
                                                     type: 'submit',
                                                     name: 'empty',
                                                     value: 'fields.SUBMIT'
                                                 }
                                                 ],
                                                 validate: function(){
                                                     var errors = [];
                                                          for(var i=0; i<this.fields.length; i++){
                                                                  var field = this.fields[i];
                                                                  if(field.required && !this.model[field.name]){
                                                                      errors.push({field:field,error:'required'});
                                                                  }

                                                          }
                                                          if(errors.length) {
                                                              var errorMessages ="<ul>";
                                                              for(var i=0; i<errors.length; i++){
                                                                  var e = errors[i];
                                                                  errorMessages += "<li>"
                                                                      +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                                                      +"</li>";
                                                              }
                                                              errorMessages += "</ul>";
                                                              $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                                              return false;
                                                          }
                                                          else return true;
                                                  },
                                                 submit: function(){
                                                     var model = this.model;
                                                     if(this.validate()){
                                                         ngDialog.openConfirm({
                                                             template: '/app/views/entities/confirm.html',
                                                             className: 'ngdialog-theme-default',
                                                             scope: $scope
                                                           }).then(function (value) {
                                                             $scope.addSavingForm.status = 'submitting';
                                                             $scope.model.action = 'AddGroupSaving';
                                                             $scope.model.saving = model;
                                                             D.save('group', $scope.model).then(
                                                                     function(response){
                                                                         $scope.addSavingForm.status = 'submitted';

                                                                         $timeout(function(){ $state.go('app.entity', {
                                                                             type: 'group',
                                                                             filter: $scope.id,
                                                                             action: 'credits'
                                                                         }, { reload: true }) }, CONFIG.stateGoTimeout)
                                                                     }
                                                                     
                                                             ).catch(function(response){
                                                                         $scope.addSavingForm.status = 'error';

                                                                     });
                                                        });
                                                     }
                                                 }
                                };
                                }
                            ).catch(console.error)



                			//$scope.form.model = $scope.model;

                		}
                		
                ).catch(function(error){
                			$scope.error = error;
                		});

            } else if($state.params.action=='orders'){

                $scope.openEditOrder = function(o){
                    $scope.orderEditForm = Object.assign({}, $scope.orderForm)
                    $scope.orderEditForm.model = o
                    $scope.orderEditForm.title = ''
                    $scope.orderEditForm.fields.forEach(function(f){
                        if(f.name=='number') f.type='static'
                    })
                    ngDialog.open({
                        template: '/app/views/entities/order-edit.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope
                      })
                }

                

                $scope.deleteOrder = function(o){
                    ngDialog.openConfirm({
                        template: '/app/views/entities/confirm.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope
                    }).then(function (value) {
                        D.remove('order', o.id).then(function(response){
                            D.query('order', 'client='+$scope.model.id).then(function(data){
                                $scope.orders = data
                            }).catch(console.error)
                        }).catch(function(err){
                            $scope.pop('error', $filter('translate')('labels.ORDERNOTDELETABLE'));
                        })
                    })
                }
                
                $scope.page.title = 'fields.ORDERS'
                D.load($scope.type, $scope.id, { cache: false }).then(
                    function(model){
                        $scope.model = model;
                        $scope.page.subTitle = model.name;
                        

                        D.query('order', 'client='+$scope.model.id, { cache: false }).then(function(data){
                            $scope.orders = data

                            $scope.orderDetailsTable = {
                                title: '',
                                filter: false,
                                fields: [
                                    {
                                        available: true,
                                        name: 'projectCode'
                                    },{
                                        available: true,
                                        name: 'total',
                                        type: 'currency',
                                        decimals: 2,
                                        def: '-',
                                        decimalSep: $rootScope.user.decimalSep,
                                        style: { textAlign: 'right' },
                                        currency: $scope.model.currency,
                                        conditionalStyle: function(m){
                                            if(m.total==0){
                                                return { display: 'none' }
                                            }
                                        }
                                    }
                                ]
                            }

                            $scope.ordersTable = {
                                title: '',
                                filter: true,
                                fields: [
                                    {
                                        available: true,
                                        name: 'number',
                                        label: 'ORDERNUMBER',
                                        filterType: 'text',
                                        filterValue: ''
                                    },{
                                        available: true,
                                        name: 'value',
                                        label: 'ORDERAMOUNT',
                                        type: 'currency',
                                        decimals: 2,
                                        def: 0,
                                        decimalSep: $rootScope.user.decimalSep,
                                        style: { textAlign: 'right' },
                                        currency: $scope.model.currency
                                    },{
                                        available: true,
                                        name: 'remaining',
                                        type: 'currency',
                                        decimals: 2,
                                        def: 0,
                                        decimalSep: $rootScope.user.decimalSep,
                                        style: { textAlign: 'right' },
                                        currency: $scope.model.currency,
                                        conditionalStyle: function(m){
                                            if(m.remaining>0) return { color: '#196F3D' }
                                            else return {color:'#A93226'}
                                        }
                                    },{
                                        available: true,
                                        type: 'date',
                                        name: 'date'
                                    },{
                                        available: true,
                                        type: 'number',
                                        name: 'projects',
                                        def: 0
                                    },{
                                        available: true,
                                        name: 'notes',
                                        type: 'ellipsed'
                                    },{
                                        available: true,
                                        name: 'viewOffers',
                                        noLabel: true,
                                        iconTooltip: 'fields.PROJECTS',
                                        type: 'click',
                                        icon: 'aqi-files',
                                        onclick: function(m){
                                            $scope.orderOffers = null
                                            $scope.orderDetailNumber = m.number
                                            D.query('offer', '_mode=list&client=' + $scope.model.id + '&_order=' + m.number).then(function(offerData){
                                                $scope.orderOffers = []
                                                if(m.compensations){
                                                    var comp = m.compensations.split(';')
                                                    comp.forEach(function(c){
                                                        var cc = c.split('|')
                                                        $scope.orderOffers.push({
                                                            projectCode: $filter('translate')('fields.ORDER') + ': ' + cc[0],
                                                            total: parseFloat(cc[1])
                                                        })
                                                        
                                                    })
                                                }
                                                offerData.forEach(function(o){
                                                    o.total = -(o.total + ($scope.model.id=='leo' ? o.service-o.serviceDiscount : 0))
                                                })
                                                $scope.orderOffers = $scope.orderOffers.concat(offerData)
                                            }).catch(console.error)
                                            ngDialog.open({
                                                template: '/app/views/entities/order-offers.html',
                                                className: 'ngdialog-theme-default',
                                                scope: $scope
                                              })
                                        }
                                    },{
                                        available: $rootScope.user.admin,
                                        name: 'editorder',
                                        noLabel: true,
                                        iconTooltip: 'labels.EDIT',
                                        type: 'click',
                                        onclick: $scope.openEditOrder,
                                        icon: 'aqi-action-edit'
                                    },{
                                        available: $rootScope.user.admin,
                                        name: 'deleteorder',
                                        noLabel: true,
                                        iconTooltip: 'labels.DELETE',
                                        type: 'click',
                                        onclick: $scope.deleteOrder,
                                        icon: 'aqi-action-delete'
                                    }
                                ]
                            }

                            $scope.orderForm = {
                                title: 'labels.ADDORDER',
                                status: '',
                                type: 'order',
                                model: { client: $scope.model.id },
                                fields: [
                                    {
                                        available: true,
                                        type: 'text',
                                        name: 'number',
                                        label: 'fields.ORDERNUMBER',
                                        labelColumn: 4,
                                        inputColumn: 8,
                                        required: true
                                    },{
                                        available: true,
                                        type: 'decimal',
                                        name: 'value',
                                        postfix: $filter('translate')('enums.currencySymbol.' + $scope.model.currency),
                                        decimals: 2,
                                        labelColumn: 4,
                                        inputColumn: 8,
                                        required: true,
                                        decimalSep: $rootScope.user.decimalSep
                                    },{
                                        available: true,
                                        type: 'textarea',
                                        name: 'notes',
                                        labelColumn: 4,
                                        inputColumn: 8
                                    },{
                                        available: true,
                                        type: 'date',
                                        name: 'date',
                                        minDate: new Date(2015,1,1),
                                        labelColumn: 4,
                                        inputColumn: 8
                                    },{
                                        available: true,
                                        type: 'select',
                                        name: 'compensate',
                                        data: $scope.orders.filter(function(o){ return o.remaining<0 }),
                                        valueField: 'number',
                                        labelField: 'number',
                                        labelColumn: 4,
                                        inputColumn: 8,
                                        placeholder: '-'
                                    },{
                                        available: true,
                                        type: 'separator'
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        value: 'fields.SUBMIT'
                                    }
                                ],
                                validate: function(){
                                    var errors = [];
                                        for(var i=0; i<this.fields.length; i++){
                                                var field = this.fields[i];
                                                if(field.required && !this.model[field.name]){
                                                    errors.push({field:field,error:'required'});
                                                }
    
                                        }
                                        if(errors.length) {
                                            var errorMessages ="<ul>";
                                            for(var i=0; i<errors.length; i++){
                                                var e = errors[i];
                                                errorMessages += "<li>"
                                                    +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')(e.field.label || 'fields.'+e.field.name.toUpperCase()) })
                                                    +"</li>";
                                            }
                                            errorMessages += "</ul>";
                                            $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                            return false;
                                        }
                                        else return true;
                                },
                                submit: function(){
                                    var model = this.model;
                                    var form = this
                                    if(this.validate()){
                                        if(!model.id) {
                                            $scope.confirmLabel = 'CONFIRMORDER'
                                            $scope.model.ordernumber = model.number
                                        } else {
                                            $scope.confirmLabel = 'CONFIRMORDEREDIT'
                                        }
                                        ngDialog.openConfirm({
                                            template: '/app/views/entities/confirm-withlabel.html',
                                            className: 'ngdialog-theme-default',
                                            scope: $scope
                                        }).then(function (value) {
                                            form.status = 'submitting';
                                            D.save('order', model).then(
                                                    function(response){
                                                        ngDialog.close()
                                                        form.status = 'submitted';
    
                                                        $timeout(function(){ $state.go('app.entity', {
                                                            type: 'group',
                                                            filter: $scope.id,
                                                            action: 'orders'
                                                        }, { reload: true }) }, CONFIG.stateGoTimeout)
                                                    }
                                                    
                                            ).catch(function(response){
                                                        form.status = 'error';
                                                        if(response.data.msg && response.data.msg.indexOf('number=')>=0){
                                                            form.errorLabel = 'labels.ERRORORDERNUMBER'
                                                        }
                                                    });
                                    });
                                    }
                                }
                            }
                        }).catch(console.error)

                        
                    }).catch(console.error)   
                

            } else if($state.params.action=='managememories'){
                if(!$rootScope.user.admin && !$rootScope.user.opts.memories) return;
                
                $scope.page.title = 'labels.MANAGEMEMORIES'

                $scope.aqrateClientsById = {};
                D.query('tm', '_distinct=client+aqrateClient&_aggregate=numEntries&active=true').then(function(res){
                    $scope.clientsData = res
                    D.query('group','type=CLIENT&_withDisabled=true').then(function(res){
                        $scope.aqrateClients = [{id:'',name:'-'}].concat(res);
                        $scope.aqrateClients = []

                        for(let i=0; i<res.length; i++){
                            $scope.aqrateClientsById[res[i].id] = res[i];
                            if(!$scope.aqrateClients.find(a => a.id == res[i].id)){
                                $scope.aqrateClients.push({
                                    id: res[i].id,
                                    count: 0,
                                    numEntries: 0,
                                    name: res[i].name
                                })
                            }
                        }

                        $scope.assignedClients = []
                        
                        $scope.clientsData.sort(function(a, b){
                            return a._value[0] < b._value[0] ? -1 : 1
                        })

                        for(let i=0; i<$scope.clientsData.length; i++){
                            let cd = $scope.clientsData[i]
                            let cid = cd._value[1] || ''
                            $scope.assignedClients.push({
                                client: cd._value[0] || '',
                                count: cd._count,
                                aqrateClient: cid,
                                aqrateClientName: $scope.aqrateClientsById[cid] && $scope.aqrateClientsById[cid].name,
                                numEntries: cd.numEntries
                            })
                            if(!$scope.aqrateClients.find(a => a.id == cid)){
                                $scope.aqrateClients.push({
                                    id: cid,
                                    count: 0,
                                    numEntries: 0,
                                    name: ($scope.aqrateClientsById[cid] && $scope.aqrateClientsById[cid].name) || '-'
                                })
                            } 
                            $scope.aqrateClients[$scope.aqrateClients.findIndex(a => a.id==cid)].count += cd._count
                            $scope.aqrateClients[$scope.aqrateClients.findIndex(a => a.id==cid)].numEntries += cd.numEntries
                        }
                        $scope.aqrateClients.sort(function(a, b){ return a.name < b.name ? -1 : 1 })

                        $scope.openSetClientForm = function(index, client, aqrateClient){
                            $scope.setClientForm = {
                                title: 'labels.SETTMSCLIENTS',
                                status: '',
                                type: 'tm',
                                model: {
                                    client: client,
                                    aqrateClient: aqrateClient,
                                    action: 'setClient'
                                },
                                fields: [
                                    { 
                                        available: true,
                                        type: 'static',
                                        name: 'client'
                                    },{
                                        available: true,
                                        type: 'select',
                                        name: 'aqrateClient',
                                        data: $scope.aqrateClients,
                                        valueField: 'id',
                                        labelField: 'name',
                                        placeholder: 'labels.SELECTCLIENT'
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty'
                                    }
                                ], submit: function(){
                                    $scope.setClientForm.status = 'submitting'
                                    D.save('tm', $scope.setClientForm.model).then(function(response){
                                        $scope.setClientForm.status = 'submitted'
                                        ngDialog.close()
                                        $scope.assignedAqrClientIds[index] = response.aqrateClientId
                                        $scope.assignedAqrClients[index] = response.aqrateClient
                                    })
                                }
                            }
                            ngDialog.open({
                                template: '/app/views/entities/tm-assignclient.html',
                                className: 'ngdialog-theme-default ngdialog-theme-large',
                                scope: $scope
                              })
                        }



                    }).catch(console.error);



                }).catch(console.error)




            } else if($state.params.action=='searchmemories'){
                if(!$rootScope.user.admin && (!$rootScope.user.opts.memories || !$rootScope.user.group.opts.searchmemories)) return;

                $scope.page.title = 'labels.SEARCHMEMORIES'

                $rootScope.$watch('clients', function(){
                    if($rootScope.clients || $rootScope.user.groupType=='CLIENT'){
                        if($state.params.filter && $state.params.filter!=$rootScope.user.group.id){
                            $scope.searchOnTM = $state.params.filter
                        }
                        if($state.params.filter){
                            D.load('tm', $state.params.filter).then(function(resp){
                                $scope.searchTMForm.model.tmName = resp.friendlyName
                            })
                        }

                        $scope.searchTMForm = {
                            title: 'labels.SEARCHMEMORIES',
                            type: 'tm',
                            status: '',
                            model: {
                                id: '*',
                                client: $rootScope.user.admin ? '' : $rootScope.user.group.id,
                                tm: $scope.searchOnTM,
                                reverse: 'source'
                            },
                            fields: [
                                {
                                    available: !!$scope.searchOnTM,
                                    type: 'static',
                                    name: 'tmName'
                                },
                                {
                                    available: true,
                                    type: 'text',
                                    name: 'segment',
                                    required: true
                                },
                                {
                                    available: $rootScope.user.admin && !$scope.searchOnTM,
                                    type: 'select',
                                    name: 'client',
                                    data: $rootScope.clients,
                                    valueField: 'id',
                                    labelField: 'name',
                                    placeholder: 'labels.SELECTCLIENT',
                                    required: true
                                },
                                {
                                    available: true && !$scope.searchOnTM,
                                    type: 'language',
                                    withEmptyOption: true,
                                    name: 'source'
                                },
                                {
                                    available: true && !$scope.searchOnTM,
                                    type: 'language',
                                    withEmptyOption: true,
                                    name: 'target'
                                },{
                                    available: true,
                                    type: 'radio',
                                    name: 'reverse',
                                    label: 'fields.SEARCHIN',
                                    options: [
                                        { value: 'source', label: 'fields.REVERSE1' },
                                        { value: 'target', label: 'fields.REVERSE' },
                                        { value: 'both', label: 'fields.REVERSE2' }
                                    ]
                                },
                                {
                                    available: true,
                                    type: 'submit',
                                    label: 'fields.SEARCH'
                                }
                            ],
                            validate: function(){
                                var errors = [];
                                
                                for(var j=0; j<this.fields.length; j++){
                                    var field = this.fields[j];
                                    if(field.required && field.available && !this.model[field.name]){
                                        errors.push({field:field,error:'required'});
                                    }
                                }


                                if(errors.length) {
                                    var errorMessages ="<ul>";
                                    for(var i=0; i<errors.length; i++){
                                        var e = errors[i];
                                        errorMessages += "<li>"
                                            +$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
                                            +"</li>";
                                    }
                                    errorMessages += "</ul>";
                                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                                    return false;
                                }
                                else return true;
                            },
                            submit: function(){
                                if(this.validate()){
                                    $scope.searchTMForm.status = 'submitting'
                                    $scope.resultId = ''
                                    $scope.searchedTms = []
                                    $scope.lookupData = []
                                    D.query('tm', 'aqrateClient=' + this.model.client + 
                                        '&manageable=true' +
                                        (this.model.source && this.model.source!='-' ? '&source=' + this.model.source : '') + 
                                        (this.model.target && this.model.target!='-' ? '&target=' + this.model.target : '') +
                                        '&_export=true').then(function(res){
                                            $scope.searchedTms = res
                                            for(let i=0; i<$scope.searchedTms.length; i++){
                                                $scope.searchedTms[i].index = i+1;
                                                $scope.searchedTms[i].found = undefined
                                                $scope.searchedTms[i].foundR = undefined
                                            }
                                            if($scope.lookupTableForm && $scope.lookupTableForm.model){ 
                                                $scope.lookupTableForm.model = null 
                                            }
                                            $scope.lookupTableForm = $scope.lookupTableFormFn($scope.searchedTms, [])
                                            $scope.searchResults = $scope.totalSearchResults = 0
                                            $scope.searchTMForm.status = 'submitted'
                                            $scope.lookupTable.loading = true;
                                            $scope.lookupData = []
                                            $scope.lookupTable.title = $filter('translate')('labels.LOOKUPRESULT')
                                            $scope.lookupTable.availableFields = $scope.lookupTable.fields.filter(function(e){ return e.available; });
                                            $scope.lookupTable.highlight = $scope.searchTMForm.model.segment;
                                            D.save('tm', { action: 'searchAllTMs', tms: $scope.searchedTms, segment: $scope.searchTMForm.model.segment, reverse: $scope.searchTMForm.model.reverse }).then(function(res){
                                                $scope.resultId = res.id;
                                                $scope.lookupData = []
                                                $scope.searchResults = $scope.totalSearchResults = 0
                                                $scope.lookupTable.title = $filter('translate')('labels.LOOKUPRESULT')
                                                for(let i=0; i<$scope.searchedTms.length; i++){
                                                    $scope.searchedTms[i].index = i+1;
                                                    $scope.searchedTms[i].found = undefined
                                                    $scope.searchedTms[i].foundR = undefined
                                                }
                                                ((resId) => {
                                                    let thisResId = resId
                                                    let unsub1 = FIREBASE.listen('TM', $scope.resultId, function(value){
                                                        if(thisResId != $scope.resultId) {
                                                            if(unsub1) unsub1()
                                                            return
                                                        }
                                                        if(value){
                                                            for(let k in value){
                                                                for(let tm of $scope.searchedTms){
                                                                    if(tm.id==k){
                                                                        $timeout(function(){
                                                                            tm.found = value[k];
                                                                            if(tm.found<0) tm.found = '#ERROR'
                                                                        },0)
                                                                        break
                                                                    }
                                                                    if(tm.id+'reverse'==k){
                                                                        $timeout(function(){
                                                                            tm.foundR = value[k]
                                                                            if(tm.foundR<0) tm.foundR = '#ERROR'
                                                                        },0)
                                                                    }
                                                                }
                                                            }
                                                            $timeout(function(){
                                                                if($scope.searchTMForm.model.reverse=='source') $scope.searchResults = $scope.searchedTms.filter(tm => tm.found>=0).length
                                                                if($scope.searchTMForm.model.reverse=='target') $scope.searchResults = $scope.searchedTms.filter(tm => tm.foundR>=0).length
                                                                if($scope.searchTMForm.model.reverse=='both') $scope.searchResults = $scope.searchedTms.filter(tm => tm.found>=0 && tm.foundR>=0).length
                                                                if($scope.searchTMForm.model.reverse=='source') $scope.totalSearchResults = $scope.searchedTms.filter(tm => tm.found!==undefined).length
                                                                if($scope.searchTMForm.model.reverse=='target') $scope.totalSearchResults = $scope.searchedTms.filter(tm => tm.foundR!==undefined).length
                                                                if($scope.searchTMForm.model.reverse=='both') $scope.totalSearchResults = $scope.searchedTms.filter(tm => tm.found!==undefined && tm.foundR!==undefined).length
                                                                if($scope.totalSearchResults==$scope.searchedTms.length){
                                                                    $scope.searchTMForm.status = 'searchCompleted'
                                                                    $scope.lookupTableForm.fields[0].available=true
                                                                    $scope.lookupTableForm.fields[1].available=$scope.filteredLookupData && $scope.filteredLookupData.length>100
                                                                }    
                                                            },0)
                                                        }
                                                    })
                                                    let unsub2 = FIREBASE.listen('results', $scope.resultId + '/data', function(data){
                                                        if(thisResId != $scope.resultId) {
                                                            if(unsub2) unsub2()
                                                            return
                                                        }
                                                        if(data.data) data = data.data
                                                        if(data){
                                                            $timeout(function(){
                                                                $scope.lookupAllData = data.map(d => { return Object.assign({}, d, d.TMEntry) })
                                                                $scope.filteredLookupData = $scope.lookupAllData.filter(d => !$scope.lookupTableForm.model.tm || d.tmIndex===$scope.lookupTableForm.model.tm)
                                                                $scope.lookupData = $scope.lookupAllData.slice($scope.lookupTableForm.model.page*$scope.lookupTableForm.model.pageSize, $scope.lookupTableForm.model.page*$scope.lookupTableForm.model.pageSize+$scope.lookupTableForm.model.pageSize)
                                                                $scope.lookupTable.title = $filter('translate')('labels.LOOKUPRESULT') + ': ' + $filter('display')($scope.filteredLookupData.length, {type:'number',def:0}) + '/' + $filter('display')($scope.lookupAllData.length, {type:'number',def:0})
                                                                $scope.lookupTable.loading = false;
                                                                $scope.lookupTable.finished = true;
                                                                $scope.lookupTable.elementsLoaded = data.length;
                                                                $scope.lookupTableForm.model.elements = $scope.filteredLookupData.length
                                                                let pages = [];
                                                                for (let i = 0; i < $scope.lookupTableForm.model.elements; i += $scope.lookupTableForm.model.pageSize) {
                                                                    pages.push({
                                                                        value: i / $scope.lookupTableForm.model.pageSize,
                                                                        label: `${i + 1}-${Math.min(i + $scope.lookupTableForm.model.pageSize, $scope.lookupTableForm.model.elements)}`
                                                                    });
                                                                }
                                                                $scope.lookupTableForm = $scope.lookupTableFormFn($scope.searchedTms, pages)    
                                                            },0)
                                                        }
                                                    }, function(err){

                                                    }, { noRT: true, noWorkaroundOnUndefined: true })
                                                })(res.id)
                                            })
                                    })
                                }
                            }
                        }

                        $scope.lookupTableFormFn = function(tms,pages){
                            tms = [{ id: '', name: $filter('translate')('labels.ALL') }].concat(tms)
                            return {
                                title: '',
                                type: 'tm',
                                status: '',
                                cls: 'form-compact form-transparent',
                                model: $scope.lookupTableForm && $scope.lookupTableForm.model ? $scope.lookupTableForm.model : {
                                    page: 0,
                                    pageSize: 100,
                                    elements: 0,
                                    tm: 0
                                },
                                fields: [
                                    {
                                        available: $scope.searchTMForm.status == 'searchCompleted',
                                        type: 'select',
                                        name: 'tm',
                                        data: tms,
                                        valueField: 'index',
                                        labelField: 'name',
                                        placeholder: ' ',
                                        onchange: function(){
                                            $scope.lookupTableForm.model.page = 0
                                            $scope.filteredLookupData = $scope.lookupAllData.filter(d => !$scope.lookupTableForm.model.tm || d.tmIndex===$scope.lookupTableForm.model.tm)
                                            $scope.lookupData =  $scope.filteredLookupData.slice($scope.lookupTableForm.model.page*$scope.lookupTableForm.model.pageSize, $scope.lookupTableForm.model.page*$scope.lookupTableForm.model.pageSize+$scope.lookupTableForm.model.pageSize)
                                            $scope.lookupTableForm.fields.find(f => f.name=='page').available = $scope.filteredLookupData && $scope.filteredLookupData.length>100
                                            pages = [];
                                            for (let i = 0; i < $scope.filteredLookupData.length; i += $scope.lookupTableForm.model.pageSize) {
                                                pages.push({
                                                    value: i / $scope.lookupTableForm.model.pageSize,
                                                    label: `${i + 1}-${Math.min(i + $scope.lookupTableForm.model.pageSize, $scope.filteredLookupData.length)}`
                                                });
                                            }
                                            $scope.lookupTable.title = $filter('translate')('labels.LOOKUPRESULT') + ': ' + $filter('display')($scope.filteredLookupData.length, {type:'number',def:0}) + '/' + $filter('display')($scope.lookupAllData.length, {type:'number',def:0})
                                            $scope.lookupTableForm = $scope.lookupTableFormFn($scope.searchedTms, pages);
    
                                        }
                                    },{
                                        available: $scope.filteredLookupData && $scope.filteredLookupData.length>100 && $scope.searchTMForm.status == 'searchCompleted',
                                        type: 'select',
                                        name: 'page',
                                        data: pages,
                                        label: 'fields.VIEWELEMENTS',
                                        valueField: 'value',
                                        labelField: 'label',
                                        placeholder: ' ',
                                        onchange: function(){
                                            $scope.filteredLookupData = $scope.lookupAllData.filter(d => !$scope.lookupTableForm.model.tm || d.tmIndex===$scope.lookupTableForm.model.tm)
                                            $scope.lookupData = $scope.filteredLookupData.slice($scope.lookupTableForm.model.page*$scope.lookupTableForm.model.pageSize, $scope.lookupTableForm.model.page*$scope.lookupTableForm.model.pageSize+$scope.lookupTableForm.model.pageSize)
                                        }
                                    }
                                ]
                            }
                        }
                        $scope.lookupTableForm = $scope.lookupTableFormFn($scope.searchedTms, [])

                        $scope.lookupTable = {
                            title: 'labels.LOOKUPRESULT',
                            fields: [
                                {
                                    available: true,
                                    name: 'tmIndex',
                                    type: 'text'
                                },
                                {
                                    available: true,
                                    name: 'EntryId',
                                    type: 'text'
                                },{
                                    available: true,
                                    name: 'empty',
                                    type: 'click',
                                    icon: 'aqi-action-expand',
                                    toggledIcon: 'aqi-action-contract',
                                    iconTooltip: 'labels.VIEWCONTEXT',
                                    onclick: function(model){
                                        $scope.tm = $scope.searchedTms.find(tm => tm.id == model.tmId)
                                        $scope.tm.action = 'getEntry';
                                        $scope.tm.sourceSegment = model.EntryId;
                                        model.SourceSegment = '<i class="aqi-action-loading"></i>'
                                        D.save('tm', $scope.tm).then(function(response){
                                            var segment = JSON.parse(response.lookupResult)
                                            for(var i=0; i<$scope.lookupData.length; i++){
                                                if($scope.lookupData[i].EntryId==model.EntryId){
                                                    if(!$scope.lookupData[i]._clickStatusToggled){
                                                        $scope.lookupData[i]._clickStatusToggled = true
                                                        $scope.lookupData[i].SourceSegment = ('<div class="tmEntryRelatedSegment">' + segment.PrecedingSegment + '</div>' + segment.SourceSegment + '<div class="tmEntryRelatedSegment">' + segment.FollowingSegment + '</div>').replace('<seg>','').replace('</seg>','')
                                                    } else {
                                                        $scope.lookupData[i]._clickStatusToggled = false
                                                        $scope.lookupData[i].SourceSegment = (segment.SourceSegment).replace('<seg>','').replace('</seg>','')
                                                    }
                                                }
                                            }
                                        }).catch(console.error)
                                    }
                                },
                                {
                                    available: true,
                                    name: 'SourceSegment',
                                    type: 'html'
                                },{
                                    available: true,
                                    name: 'TargetSegment',
                                    type: 'html'
                                },{
                                    available: $rootScope.user.opts.writememories,
                                    name: 'empty',
                                    type: 'click',
                                    icon: 'aqi-action-edit',
                                    onclick: function(model){
                                        $scope.tm = $scope.searchedTms.find(tm => tm.id == model.tmId)
                                        $scope.tm.action = 'getEntry';
                                        $scope.tm.sourceSegment = model.EntryId;
                                        D.save('tm', $scope.tm).then(function(response){
                                            var segment = JSON.parse(response.lookupResult)
                                            
                                            $scope.tm.editSourceSegment = segment.SourceSegment.replace('<seg>','').replace('</seg>','');
                                            $scope.tm.editTargetSegment = segment.TargetSegment.replace('<seg>','').replace('</seg>','');
                                            $scope.tm.oldSourceSegment = segment.SourceSegment.replace('<seg>','').replace('</seg>','');
                                            $scope.tm.oldTargetSegment = segment.TargetSegment.replace('<seg>','').replace('</seg>','');
                                            $scope.tm.editModified = segment.Modified;
                                            $scope.tm.editEntryId = segment.Key;
                                            $scope.tm.customMetas = segment.CustomMetas;
                                            $scope.tmEditForm.status = '';
                                            $scope.tmEditForm.model = $scope.tm;
                                            ngDialog.open({
                                                  template: '/app/views/entities/tm-edit.html',
                                                  className: 'ngdialog-theme-large',
                                                  scope: $scope,
                                                  cache: false
                                              });
                                        }).catch(console.error);
                                    }
        
                                }
                            ]
                        }

                        $scope.tmEditForm = {
                            title: 'labels.TMEDIT',
                            status: '',
                            type: 'tm',
                            model: $scope.tm,
                            fields: [
                                {
                                    available: true,
                                    name: 'editSourceSegment',
                                    type: 'textarea'
                                },{
                                    available: true,
                                    name: 'editTargetSegment',
                                    type: 'textarea'
                                },{
                                    available: true,
                                    type: 'submit'
                                }
                            ],
                            submit: function(){
                                $scope.tm.action = 'edit';
                                $scope.tmEditForm.status = 'submitting';
                                D.save('tm', $scope.tm).then(function(response){
                                    $scope.tmEditForm.status = '';
                                    ngDialog.close();
                                    $scope.lookupForm.submit();
                                }).catch(function(){
                                    $scope.tmEditForm.status = 'error';
                                });
                            }
                        }
                    }
                })


            } else if($state.params.action=='memories'){
                if(!$rootScope.user.opts.memories) return;

                $scope.tmsTable = {
                        type: 'tm',
                        title: '',
                        filter: true,
                        includedFields: ['id'],
                        links: !$state.params.filter || $state.params.filter=='_uploaded' ? [
                             {
                                link: {
                                    action: 'memories',
                                    type: 'group',
                                    filterValue: !$state.params.filter ? '_uploaded' : ''
                                },
                                label: !$state.params.filter ? 'labels.UPLOADEDTMS' : 'labels.MEMOQTMS'
                            }
                        ] : null,
                        commandButtons: $state.params.filter!='_uploaded' ? [
                            {
                                available: $rootScope.user.group.type=='ADMIN',
                                label: 'labels.SAVEALLMEMORIES',
                                cls: 'btn-primary',
                                onclick: function(){
                                    ngDialog.openConfirm({
                                       template: '/app/views/entities/confirm.html',
                                       className: 'ngdialog-theme-default',
                                       scope: $scope
                                   }).then(function (value) {
                                        var models = $filter('filter')($scope.tms, $scope.filterData);
                                        var field = $scope.tmsTable.fields.filter(function(f){ return f.name==='visible';})[0];
                                        for(let i=0; i<models.length; i++) {
                                            if(models[i]._status_visible==='status-pending'){
                                                field.onchange(models[i]);
                                            }
                                        }
                                        field = $scope.tmsTable.fields.filter(function(f){ return f.name==='manageable';})[0];
                                        for(let i=0; i<models.length; i++) {
                                            if(models[i]._status_manageable==='status-pending'){
                                                field.onchange(models[i]);
                                            }
                                        }
                                    });
                                }
                            },{
                                available: $rootScope.user.group.type=='ADMIN',
                                label: 'fields.MANAGEABLE',
                                name: 'selectedAllAsManageable',
                                isCheckbox: true,
                                onclick: function(){
                                        var models = $filter('filter')($scope.tms, $scope.filterData);
                                        for(let i=0; i<models.length; i++) {
                                            if($scope.selectedAllAsManageable){
                                                if(models[i].manageable!==false){
                                                    models[i]._status_manageable = 'status-pending';
                                                    models[i].manageable = false;
                                                }
                                            } else {
                                                if(models[i].manageable!==true){
                                                    models[i]._status_manageable = 'status-pending';
                                                    models[i].manageable = true;
                                                }
                                            }
                                        }
                                        if($scope.selectedAllAsManageable){
                                            $scope.selectedAllAsManageable = false;
                                        } else {
                                            $scope.selectedAllAsManageable = true;
                                        }

                                }
                            },{
                                available: $rootScope.user.group.type=='ADMIN',
                                label: 'fields.VISIBLE',
                                name: 'selectedAllAsVisible',
                                isCheckbox: true,
                                onclick: function(){

                                        var models = $filter('filter')($scope.tms, $scope.filterData);
                                        for(let i=0; i<models.length; i++) {
                                            if($scope.selectedAllAsVisible){
                                                if(models[i].visible!==false){
                                                    models[i]._status_visible = 'status-pending';
                                                    models[i].visible = false;
                                                }
                                            } else {
                                                if(models[i].visible!==true){
                                                    models[i]._status_visible = 'status-pending';
                                                    models[i].visible = true;
                                                }
                                            }
                                        }
                                        if($scope.selectedAllAsVisible){
                                            $scope.selectedAllAsVisible = false;
                                        } else {
                                            $scope.selectedAllAsVisible = true;
                                        }

                                }
                            }
                        ] : [
                            {
                                available: $rootScope.user.group.type=='ADMIN',
                                label: 'labels.UPLOADTM',
                                cls: 'btn-primary',
                                onclick: function(){
                                    let tempId = $rootScope.generateUUID(true, 'TM-')
                                    $scope.popupForm = {
                                        title: 'labels.UPLOADTM',
                                        status: 'notsubmittable',
                                        type: 'tm',
                                        model: { 
                                            tempId: tempId
                                        },
                                        refreshFile: function(data){
                                            if($rootScope.files['tm'+tempId+'file'] && $rootScope.files['tm'+tempId+'file'].length>0)
                                                this.status = '';
                                            else
                                                this.status = 'notsubmittable';
                                        },
                                        fields: [
                                            {
                                                available: true,
                                                type: 'file',
                                                name: 'file',
                                                limit: 1,
                                                allow: 'tmx',
                                                noLabel: true,
                                                inputColumn: 12,
                                                labelColumn: 0,
                                                canUpload: true,
                                                bucket: $rootScope.bucketName('')
                                            },{
                                                available: true,
                                                type: 'text',
                                                name: 'client'
                                            },{
                                                available: true,
                                                type: 'submit',
                                                name: 'empty',
                                                value: 'fields.SUBMIT'
                                            }
                                        ],
                                        submit: function(){
                                            this.status = 'submitting';
                                            var model = this.model;
                                            model.action = 'UploadNewTM';
                                            D.save('tm', model).then(
                                                    function(response){
                                                        $scope.popupForm.status = 'submitted';
                                                        ngDialog.close()
                                                        $timeout(function(){ $state.go('app.entity', {
                                                            type: 'tm',
                                                            filter: response.id,
                                                            action: 'lookup'
                                                        }) }, CONFIG.stateGoTimeout)
                                                    }
                                                    
                                            ).catch(function(response){
                                                        $scope.popupForm.status = 'error';
                                                    });
                                        }
                                    }
                                    ngDialog.open({
                                        template: '/app/views/entities/popup-form.html',
                                        className: 'ngdialog-theme-default ngdialog-theme-large',
                                        scope: $scope
                                      })
                                }
                            }
                        ],
                        fields: [
                            {
                                available: true,
                                name: 'name',
                                hasLink: true,
                                filterType: 'text',
                                filterValue: ''
                            },{
                                available: $rootScope.user.group.type=='ADMIN',
                                name: 'client',
                                filterType: 'text',
                                filterValue: ''
                            },{
                                available: $rootScope.user.group.type=='ADMIN',
                                name: 'aqrateClient',
                                filterType: 'clients',
                                filterValue: ''
                            },{
                                available: true,
                                name: 'numEntries',
                                type: 'number'
                            },{
                                available: true,
                                name: 'source',
                                type: 'enum',
                                enumType: 'language',
                                filterType: 'language',
                                filterValue: '',
                            },{
                                available: true,
                                name: 'target',
                                type: 'enum',
                                enumType: 'language',
                                filterType: 'language',
                                filterValue: '',
                            },{
                                available: $rootScope.user.group.type=='ADMIN' && $state.params.filter!='_uploaded',
                                name: 'visible',
                                type: 'checkbox',
                                onchange: function(model){
                                    model.action = 'editVisible';
                                    model._status_visible = 'status-pending';
                                    D.save('tm', model).then(function(response){
                                        D.load('tm', model.id).then(function(response){
                                            model._status_visible = '';
                                            model.visible = response.visible;
                                        });
                                    }).catch(function(err){
                                        model._status_visible = 'status-error';
                                        model.visible = !model.visible;
                                        D.load('tm', model.id).then(function(response){
                                            model.visible = response.visible;
                                        }).catch(console.error);

                                    });
                                }
                            },{
                                available: $rootScope.user.group.type=='ADMIN' && $state.params.filter!='_uploaded',
                                name: 'manageable',
                                type: 'checkbox',
                                onchange: function(model){
                                    model.action = 'editManageable';
                                    model._status_manageable = 'status-pending';
                                    D.save('tm', model).then(function(response){
                                        D.load('tm', model.id).then(function(response){
                                            model._status_manageable = '';
                                            model.manageable = response.manageable;
                                        }).catch(console.error);
                                    }).catch(function(err){
                                        model._status_manageable = 'status-error';
                                        model.manageable = !model.manageable;
                                        D.load('tm', model.id).then(function(response){
                                            model.manageable = response.manageable;
                                        }).catch(console.error);
                                    });
                                }
                            },{
                                available: true,
                                name: 'lastModified',
                                label: 'TMDATE',
                                type:'date'
                            }
                        ],
                        link: {
                            action: 'lookup',
                            type: 'tm',
                            filter: 'id'
                        }
                    };

                    $scope.askDownloadAllForm = {
                        title: $rootScope.user.admin ? 'labels.DOWNLOADALLCLIENTTMS' : 'labels.DOWNLOADALLTMS',
                        type: 'job',
                        status: '',
                        model: { action:'askForTMsZip', client: $scope.id },
                        fields: [
                            {
                                available: true,
                                type: 'submit'
                            }
                        ],
                        submit: function(){
                            $scope.askDownloadAllForm.status = 'submitting'
                            D.save('tm', this.model).then(function(response){
                                $scope.askDownloadAllForm.status = 'submitted'
                                $scope.askDownloadAllForm.successLabel = $filter('translate')('labels.ASKEDTMSDOWNLOAD')
                            })
                        }
                    }

                    $scope.downloadAllForm = {
                        title: $rootScope.user.admin ? 'labels.DOWNLOADALLCLIENTTMS' : 'labels.DOWNLOADALLTMS',
                        type: 'job',
                        status: '',
                        model: { id:'zipAllTMs', client: $scope.id },
                        fields: [
                            {
                                available: true,
                                type: 'submit'
                            }
                        ],
                        submit: function(){
                            $scope.downloadAllForm.status = 'notsubmittable'
                            D.save('job', $scope.downloadAllForm.model).then(function(resp){
                                $scope.downloadJobs = resp.data.jobs
                            }).catch(function(err){
                                $scope.downloadAllForm.status = 'error'
                            })
                        }
                    }

                    $scope.tmsTable.baseFilter = $state.params.filter ? ($state.params.filter=='_uploaded' ? 'origin=upload' : 'aqrateclient=' + $scope.id) : ''

                    $scope.tmsTable.loadCallback = function(){
                        if($rootScope.user.group.type=='ADMIN' && $scope.tms && $scope.tms.length){
                            $scope.showSetClientsForm = false;
                            $scope.showSetClientsFormButton = true;
                            $scope.setShowClientForm = function(){$scope.showSetClientsForm = true;}
                            $scope.showTMsForm = true;
                            $scope.aqrateClientsById = {};
                            D.query('group','type=CLIENT', { cache: false }).then(function(res){
                                $scope.aqrateClients = [{id:'',name:'-'}].concat(res);
                                for(var i=0; i<res.length; i++){
                                    $scope.aqrateClientsById[res[i].id] = res[i];
                                }



                                $scope.assignedClients = [];
                                $scope.assignedAqrClients = [];
                                $scope.assignedAqrClientIds = [];
                                var _tm = $scope.tms[0];
                                


                                $scope.tmsForm = {
                                    title: 'labels.UPDATETMXFILES',
                                    status: '',
                                    type: 'tm',
                                    model: _tm,
                                    fields: [{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty'
                                    }],
                                    submit: function(){
                                        $scope.tmsForm.status = 'submitting';
                                        D.load('memoq', 'TMs').then(
                                            function(response){
                                                $scope.tmsForm.status = 'notsubmittable';
                                            }
                                            
                                        ).catch(function(response){
                                                $scope.tmsForm.status = 'error';
                                            });
                                    }
                                };

                        })

                    }
                }



                
                    

                    


		    	D.load($scope.type, $scope.id, { cache: false }).then(
                		function(model){
                			$scope.model = model;
                			$scope.page.title = 'labels.MEMORIES';
                			$scope.page.subTitle = model.name;
                			$scope.form = {
                					title: '',
                					status: '',
                					type: 'group',
                					model: $scope.model,
                					fields: [
												{
												    available: true,
												    type: 'file',
												    name: 'memories',
												    canUpload: $rootScope.user.admin,
												    cantDelete: !$rootScope.user.admin,
												    noLabel: true,
												    inputColumn: 12,
												    limit: -1,
												    allow: '',
                                                    bucket: $rootScope.bucketName($scope.model.id),
                                                    filesSelectable: $rootScope.user.admin,
                                                    selectionActions: [
                                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                                    ] 
												}
                					         ],
                					         submit: function(){

                					         }
                			};

                		}
                		
                ).catch(function(error){
                			$scope.error = error;
                		});

            } else if($scope.id=="" || $scope.id=="CLIENT" || $scope.id=="client" || $scope.id=="SUPPLIER" || $scope.id=="supplier"){
		    	
		    		    D.load('account', 'group='+$rootScope.user.group.id, { cache: false }).then(
		    		    
		    		                function(model){

		    		                    $scope.model = model;

                                        var optsNames = [
                                            'searchmemories',
                                            'selfnotifications',
                                            'skipSourceReport',
                                            'manageTranslators',
                                            'canviewcsv',
                                            'canaskfortm',
                                            'offerDlFieldWTime',
                                            'hasImportProject',
                                            'receiveOfferPdf',
                                            'receiveDelivered',
                                            'skipConfirmLimit',
                                            'skipConfirm',
                                            'hasSectorInProject',
                                            'maxOneUserPerSector',
                                            'acceptingUserFromSector',
                                            'noDtpInOffers',
                                            'canUploadAsLink',
                                            'previewWords',
                                            'viewPacketTransactions',
                                            'hasReviewInProject',
                                            'sourceFilesInReview',
                                            'hasOrders',
                                            'hasReviewDeadline',
                                            'reviewMode',
                                            'recoveredPricePercentage',
                                            'doNotSubtractTranslatedWords',
                                            'hasQAi',
                                            'defaultSourceFilesVisible',
                                            'defaultAllReviewNotificationsToLa'
                                        ]

                                        for(var i in optsNames){
                                            $scope.model[optsNames[i]] = $scope.model.opts[optsNames[i]]
                                        }
                  
		    		                    if($scope.id=="CLIENT" || $scope.id=="client"){
                                            $scope.model.type = "CLIENT";
                                            $scope.model.autodelivery = true;
                                            $scope.model.selfnotifications = true;
                                            $scope.model.searchmemories = false;
                                            $scope.model.skipSourceReport = false;
                                            $scope.model.canaskfortm = false;
                                            $scope.model.offerDlFieldWTime = false;
                                            $scope.model.hasImportProject = false;
                                            $scope.model.receiveOfferPdf = false;
                                            $scope.model.receiveDelivered = false;
                                            $scope.model.noDtpInOffers = false;
                                            $scope.model.canUploadAsLink = false;
                                            $scope.model.previewWords = false;
                                            $scope.model.viewPacketTransactions = false;
                                            $scope.model.doNotSubtractTranslatedWords = false;

                                            $scope.model.currency = 'EUR'
                                            $scope.model.discountContext = '100'
                                            $scope.model.discountFull = '80'
                                            $scope.model.discountFuzzy = '50'
                                            $scope.model.discountNo = '0'

                                            $scope.model.hasQAi = false;
                                            $scope.model.defaultSourceFilesVisible = false;
                                            $scope.model.defaultAllReviewNotificationsToLa = true;
                                            $scope.model.recoveredPricePercentage = 50
		    		                    }else if($scope.id=="SUPPLIER" || $scope.id=="supplier"){
		    		                    	$scope.model.type = "SUPPLIER";
		    		                    }

                                        

		    		                    $scope.form = {
		    		            		        title: $scope.model.type == 'CLIENT' ? 'labels.ADDNEWCLIENT' : $scope.model.type == 'SUPPLIER' ? 'labels.ADDNEWSUPPLIER' : 'labels.ADDNEWGROUP',
		    		            		        status: '',
		    		            		        type: 'group',
		    		            		        model: $scope.model,
		    		            		        fields: [
                                                    {
		    		            		                available: true,
		    		            		                type: 'text',
		    		            		                name: 'name',
		    		            		                required: true
		    		            		            },{
                                                        available: false,
                                                        type: 'picture',
                                                        name: 'logo'
                                                    },{
                                                        label: 'fields.LOGO',
                                                        uploadLabel: 'fields.UPLOADLOGO',
                                                        available: false,
                                                        type: 'pictureFile',
                                                        name: 'uploadlogo',
                                                        targetField: 'logo',
                                                        limit: 1,
                                                        canUpload: true,
                                                        allow: 'jpg|jpeg|png',
                                                        bucket: $rootScope.bucketName($scope.model.id)
                                                    },{
		    		            		                available: true,
		    		            		                type: 'text',
		    		            		                name: 'code',
		    		            		                required: true
		    		            		            },{
		    		            		            	available: $scope.model.type == 'CLIENT',
		    		            		                type: 'text',
		    		            		                name: 'discountContext',
		    		            		                required: true
		    		            		            },{
		    		            		            	available: $scope.model.type == 'CLIENT',
		    		            		                type: 'text',
		    		            		                name: 'discountFull',
		    		            		                required: true
		    		            		            },{
		    		            		            	available: $scope.model.type == 'CLIENT',
		    		            		                type: 'text',
		    		            		                name: 'discountFuzzy',
		    		            		                required: true
		    		            		            },{
		    		            		            	available: $scope.model.type == 'CLIENT',
		    		            		                type: 'text',
		    		            		                name: 'discountNo',
		    		            		                required: true
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'separator'
		    		            		            },{
                                                        available: $scope.model.type == 'CLIENT',
                                                        type: 'select',
                                                        name: 'bucketLocations',
                                                        required: true,
                                                        data: [
                                                            {id:'EUROPE_WEST8+EUROPE_WEST3', name: '🇪🇺 Milano + Francoforte (🇮🇹🇩🇪)'},
                                                            {id:'EUROPE_WEST4+EUROPE_WEST3', name: '🇪🇺 Paesi Bassi + Francoforte (🇳🇱🇩🇪)'},
                                                            {id:'EUROPE_WEST1+EUROPE_WEST3', name: '🇪🇺 Belgio + Francoforte (🇧🇪🇩🇪)'},
                                                            {id:'US_WEST2+US_CENTRAL1',name: '🇺🇸 Los Angeles + Iowa'},
                                                            {id:'EUROPE_WEST2',name: '🇬🇧 Londra'},
                                                            {id:'EUROPE_WEST3',name: '🇩🇪 Francoforte'},
                                                            {id:'EUROPE_WEST4',name: '🇳🇱 Paesi Bassi'},
                                                            {id:'EUROPE_WEST6',name: '🇨🇭 Zurigo'},
                                                            {id:'EUROPE_WEST8',name: '🇮🇹 Milano'},
                                                            {id:'EUROPE_WEST9',name: '🇫🇷 Parigi'},
                                                            {id:'EUROPE_WEST12', name: '🇮🇹 Torino'},
                                                            {id:'EUROPE_SOUTHWEST1', name: '🇪🇸 Madrid'},
                                                            {id:'US_CENTRAL1', name: '🇺🇸 Iowa'},
                                                            {id:'US_EAST1', name: '🇺🇸 South Carolina'},
                                                            {id:'US_EAST4', name: '🇺🇸 Virginia'},
                                                            {id:'US_WEST1', name: '🇺🇸 Oregon'},
                                                            {id:'US_WEST2', name: '🇺🇸 Los Angeles'},
                                                            {id:'US_WEST3', name: '🇺🇸 Utah'},
                                                            {id:'US_WEST4', name: '🇺🇸 Las Vegas'},
                                                            {id:'NORTHAMERICA_NORTHEAST1', name: '🇨🇦 Montreal'},
                                                            {id:'NORTHAMERICA_NORTHEAST2', name: '🇨🇦 Toronto'}

                                                        ],
                                                        valueField: 'id',
                                                        labelField: 'name'
                                                    },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'searchmemories'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'selfnotifications'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'skipSourceReport'
		    		            		            },{
		    		            		                available: $scope.model.type == 'SUPPLIER',
                                                        type: 'checkbox',
                                                        name: 'manageTranslators'
		    		            		            },{
		    		            		                available: $scope.model.type == 'SUPPLIER',
                                                        type: 'checkbox',
                                                        name: 'canviewcsv'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'canaskfortm'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'offerDlFieldWTime'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'hasImportProject'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'receiveOfferPdf'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'receiveDelivered'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'viewPacketTransactions'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'doNotSubtractTranslatedWords'
		    		            		            },{
                                                        available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'autodelivery'
                                                    },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'noDtpInOffers'
		    		            		            },{
                                                        available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'canUploadAsLink'
                                                    },{
                                                        available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'previewWords'
                                                    },{
                                                        available: $scope.model.type == 'CLIENT',
                                                        type: 'select',
                                                        name: 'currency',
                                                        data: [{
                                                            value: '',
                                                            label: '-'
                                                        },{
                                                            value: 'EUR',
                                                            label: $filter('translate')('enums.currencyName.EUR') + ' - ' + $filter('translate')('enums.currencySymbol.EUR') 
                                                        },{
                                                            value: 'USD',
                                                            label: $filter('translate')('enums.currencyName.USD') + ' - ' + $filter('translate')('enums.currencySymbol.USD') 
                                                        },{
                                                            value: 'CAD',
                                                            label: $filter('translate')('enums.currencyName.CAD') + ' - ' + $filter('translate')('enums.currencySymbol.CAD') 
                                                        }],
                                                        valueField: 'value',
                                                        labelField: 'label',
                                                        required: true,
                                                        placeholder: ' '
                                                    },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'hasQAi'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'defaultSourceFilesVisible'
		    		            		            },{
		    		            		                available: $scope.model.type == 'CLIENT',
                                                        type: 'checkbox',
                                                        name: 'defaultAllReviewNotificationsToLa'
		    		            		            },{
                                                        available: $scope.model.type=='CLIENT',
                                                        type: 'decimal',
                                                        displayType: 'decimal',
                                                        decimalSep: $rootScope.user.decimalSep,
                                                        decimals: 0,
                                                        name: 'recoveredPricePercentage',
                                                    },{
		    		            		                available: true,
		    		            		                type: 'separator'
		    		            		            },{
		    		            		                available: true,
		    		            		                type: 'submit',
		    		            		                name: 'empty',
		    		            		                value: 'fields.SUBMIT'
		    		            		            }
		    		            		        ],
	                                             validate: function(){
                                                    var errors = [];
                                                       
	                                               	for(var j=0; j<this.fields.length; j++){
	                                         			var field = this.fields[j];
	                                         			if(field.name=='code'){
	                                         				if($('[name=code]').val().length!=3){
	                                         					errors.push({field:field,error:'3char'});
	                                                       	}
                                                         }
                                                         if(field.required && field.available && !this.model[field.name]){
                                                            errors.push({field:field,error:'required'});
                                                        }
	                                         		}


	                                               	if(errors.length) {
	                                               		var errorMessages ="<ul>";
	                                               		for(var i=0; i<errors.length; i++){
	                                               			var e = errors[i];
	                                               			errorMessages += "<li>"
	                                               				+$filter('translate')('labels.VALIDATIONERROR'+e.error.toUpperCase(), { name: $filter('translate')('fields.'+e.field.name.toUpperCase()) })
	                                               				+"</li>";
	                                               		}
	                                               		errorMessages += "</ul>";
	                                               		$scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
	                                               		return false;
	                                               	}
	                                               	else return true;
	                                               },
		    		            		        submit: function(){
		    		            		        	if(this.validate()){
			    		            		            $scope.form.status = 'submitting';
			    		            		            D.save($scope.type, $scope.model).then(
			    		            		                function(response){
			    		            		                    $scope.form.status = 'submitted';
                                                                $timeout(function(){ $state.go('app.entity', {action:'view',type:'group',filter:response.id}, { reload: true }); }, CONFIG.stateGoTimeout)
			    		            		                }
			    		            		                
			    		            		            ).catch(function(response){
			    		            		                    $scope.form.status = 'error';
			    		            		                });
		    		            		        	}
		    		            		        }
		    		            		    };
		    		                    $scope.form.model = $scope.model;
                                        $scope.loadFiles();
		    		                }
		    		                
		    		            ).catch(function(error){
		    		                    $scope.error = error;
		    		                });
		    }else{

                D.query('supergroup','', { cache: false }).then(function(response){
                    $scope.supergroups = response;
                    
                    
                    D.load($scope.type, $scope.id, { cache: false }).then(function(model){
                        D.query('account', 'group='+$scope.id+'&_withSGUsers=true', { cache: false }).then(function(users){
                                    $scope.allUsers = users;
                                    $scope.model = model;
                                    $scope.page.title = model.name;
                                    $scope.page.subTitle = model.code;

                                    var optsNames = [
                                        'searchmemories',
                                        'selfnotifications',
                                        'skipSourceReport',
                                        'manageTranslators',
                                        'canviewcsv',
                                        'canaskfortm',
                                        'offerDlFieldWTime',
                                        'hasGlossary',
                                        'autodelivery',
                                        'hasImportProject',
                                        'receiveOfferPdf',
                                        'receiveDelivered',
                                        'skipConfirmLimit',
                                        'skipConfirm',
                                        'joinProjectsDefaultUser',
                                        'hasSectorInProject',
                                        'maxOneUserPerSector',
                                        'acceptingUserFromSector',
                                        'noDtpInOffers',
                                        'canUploadAsLink',
                                        'previewWords',
                                        'viewPacketTransactions',
                                        'hasReviewInProject',
                                        'sourceFilesInReview',
                                        'hasOrders',
                                        'hasReviewDeadline',
                                        'reviewMode',
                                        'recoveredPricePercentage',
                                        'doNotSubtractTranslatedWords',
                                        'hasQAi',
                                        'defaultSourceFilesVisible',
                                        'defaultAllReviewNotificationsToLa'
                                    ]
                                    for(var oi in optsNames){
                                        $scope.model[optsNames[oi]] = $scope.model.opts[optsNames[oi]]
                                    }

                                    if($scope.model.supergroup){
                                        $scope.supergroupLines = $scope.supergroups.filter(function(sg){ return sg.id==$scope.model.supergroup;})[0].lines;
                                    }
                                    $scope.form = {
                                            title: 'labels.EDITGROUP',
                                            status: '',
                                            type: 'group',
                                            model: $scope.model,
                                            fields: [
                                                {
                                                    available: true,
                                                    type: 'static',
                                                    name: 'enabled',
                                                    displayType: 'boolean'
                                                },
                                                {
                                                    available: true,
                                                    type: 'text',
                                                    name: 'name',
                                                    required: true
                                                },{
                                                    available: false,
                                                    type: 'text',
                                                    name: 'code',
                                                    required: true
                                                },{
                                                    available: false,
                                                    type: 'picture',
                                                    name: 'logo',
                                                    required: true
                                                },{
                                                    label: 'fields.LOGO',
                                                    uploadLabel: 'fields.UPLOADLOGO',
                                                    available: true,
                                                    type: 'pictureFile',
                                                    name: 'uploadlogo',
                                                    targetField: 'logo',
                                                    limit: 1,
                                                    canUpload: true,
                                                    allow: 'jpg|jpeg|png',
                                                    public: true,
                                                    bucket: $rootScope.bucketName($scope.model.id)
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'select',
                                                    name: 'supergroup',
                                                    data: $scope.supergroups,
                                                    valueField: 'id',
                                                    labelField: 'name',
                                                    placeholder: 'labels.NONE',
                                                    onchange: function(){
                                                        $scope.form.fields.filter(function(f){ return f.name=='supergroupLine';})[0].available = !!$scope.model.supergroup;
                                                        $scope.form.fields.filter(function(f){ return f.name=='supergroupLine';})[0].data = $scope.supergroups.filter(function(sg){ return sg.id==$scope.model.supergroup;})[0].lines
                                                        $timeout(function(){
                                                            angular.element('select[name=supergroupLine]').chosen('destroy').chosen()
                                                        },500);
                                                    }
                                                },{
                                                    available: !!$scope.model.supergroup,
                                                    type: 'select',
                                                    name: 'supergroupLine',
                                                    data: $scope.supergroupLines,
                                                    valueField: 'id',
                                                    labelField: 'name',
                                                    placeholder: 'labels.NONE',
                                                    label: 'fields.LINE'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'separator'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'text',
                                                    name: 'discountContext',
                                                    label: $scope.model.id=='stl' ? 'fields.DISCOUNTMATCH100' : 'fields.DISCOUNTCONTEXT',
                                                    required: true
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'text',
                                                    name: 'discountFull',
                                                    label: $scope.model.id=='stl' ? 'fields.DISCOUNTMATCH9599' : 'fields.DISCOUNTFULL',
                                                    required: true
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'text',
                                                    name: 'discountFuzzy',
                                                    label: $scope.model.id=='stl' ? 'fields.DISCOUNTMATCH7594' : 'fields.DISCOUNTFUZZY',
                                                    required: true
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'text',
                                                    name: 'discountNo',
                                                    label: $scope.model.id=='stl' ? 'fields.DISCOUNTMATCH074' : 'fields.DISCOUNTNO',
                                                    required: true
                                                },{
                                                    available: true,
                                                    type: 'separator'
                                                },{
                                                    available: $scope.model.type == 'CLIENT' || $scope.model.type == 'ADMIN',
                                                    type: 'checkbox',
                                                    name: 'searchmemories'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'selfnotifications'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'skipSourceReport'
                                                },{
                                                    available: $scope.model.type == 'SUPPLIER',
                                                    type: 'checkbox',
                                                    name: 'manageTranslators'
                                                },{
                                                    available: $scope.model.type == 'SUPPLIER',
                                                    type: 'checkbox',
                                                    name: 'canviewcsv'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'canaskfortm'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'offerDlFieldWTime'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'hasImportProject'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'receiveOfferPdf'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'receiveDelivered'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'viewPacketTransactions'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'doNotSubtractTranslatedWords'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'autodelivery'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'noDtpInOffers'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'skipConfirm'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'canUploadAsLink'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'previewWords'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'decimal',
                                                    displayType: 'decimal',
                                                    decimalSep: $rootScope.user.decimalSep,
                                                    decimals: 0,
                                                    name: 'skipConfirmLimit',
                                                    labelParams: { currency: $scope.model.currency },
                                                    postfix: $filter('translate')('enums.currencySymbol.' + ($scope.model.currency))
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'select',
                                                    name: 'joinProjectsDefaultUser',
                                                    data: $scope.allUsers,
                                                    valueField: 'id',
                                                    labelField: 'name',
                                                    placeholder: 'labels.NONE'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'hasSectorInProject'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'hasReviewInProject',
                                                    onchange: function(){
                                                        $scope.form.fields.forEach(function(f){
                                                            if(f.name=='sourceFilesInReview' || f.name=='hasReviewDeadline' || f.name=='reviewMode'){
                                                                f.available = $scope.model.hasReviewInProject
                                                            }
                                                        });
                                                    }
                                                },{
                                                    available: $scope.model.type == 'CLIENT' && $scope.model.hasReviewInProject,
                                                    type: 'checkbox',
                                                    name: 'sourceFilesInReview'
                                                },{
                                                    available: $scope.model.type == 'CLIENT' && $scope.model.hasReviewInProject,
                                                    type: 'checkbox',
                                                    name: 'hasReviewDeadline'
                                                },{
                                                    available: $scope.model.type == 'CLIENT' && $scope.model.hasReviewInProject,
                                                    type: 'select',
                                                    name: 'reviewMode',
                                                    data: [{
                                                        value: '',
                                                        label: 'standard'
                                                    },{
                                                        value: 'memoQ',
                                                        label: 'memoQ'
                                                    }],
                                                    valueField: 'value',
                                                    labelField: 'label'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'maxOneUserPerSector'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'acceptingUserFromSector'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'hasQAi'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'defaultSourceFilesVisible'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'defaultAllReviewNotificationsToLa'
                                                },{
                                                    available: $scope.model.type == 'CLIENT' || $scope.model.type == 'ADMIN',
                                                    type: 'separator'
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'checkbox',
                                                    name: 'hasGlossary',
                                                    onchange: function(){
                                                        $scope.form.fields.filter(function(f){ return f.name=='glossary';})[0].available = !!$scope.model.hasGlossary;
                                                    }
                                                },{
                                                    available: $scope.model.type == 'CLIENT' && $scope.model.hasGlossary,
                                                    type: 'file',
                                                    name: 'glossary',
                                                    limit: -1,
                                                    canUpload: true,
                                                    canAddInstructions: true,
                                                    bucket: $rootScope.bucketName($scope.model.id),
                                                    filesSelectable: $rootScope.user.admin,
                                                    selectionActions: [
                                                        { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                                    ] 
                                                },{
                                                    available: $scope.model.type == 'CLIENT',
                                                    type: 'static',
                                                    name: 'currency',
                                                    displayType: 'enum',
                                                    enumType: 'currencyName'
                                                },{
                                                    available: $scope.model.type=='CLIENT',
                                                    type: 'decimal',
                                                    displayType: 'decimal',
                                                    decimalSep: $rootScope.user.decimalSep,
                                                    decimals: 0,
                                                    name: 'recoveredPricePercentage',
                                                },{
                                                    available: true,
                                                    type: 'separator'
                                                },{
                                                    available: true,
                                                    type: 'submit',
                                                    name: 'empty',
                                                    value: 'fields.SUBMIT'
                                                }
                                            ],
                                            submit: function(){
                                                $scope.form.status = 'submitting';
                                                D.save($scope.type, $scope.model).then(
                                                    function(response){
                                                        $scope.form.status = 'submitted';
                                                        $state.go('app.entity',{
                                                            action: 'view',
                                                            type: 'group',
                                                            filter: response.id
                                                        });
                                                    }
                                                    
                                                ).catch(function(response){
                                                        $scope.form.status = 'error';
                                                    });
                                            }
                                        };
                                    $scope.form.model = $scope.model;
                                    $scope.loadFiles();
                                },
                                function(error){
                                    $scope.error = error;
                                }
                            ).catch(console.error);
                    }).catch(console.error);
                }).catch(console.error);
    	}	
        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();
  }
  ]);
